export const messages = {
  en: {
    systemUser: {
      search: {
        title: 'Search Conditions',
        levelCd: 'Please select user role',
        nameLike: 'Please enter user name',
        tel: 'Please enter phone number'
      },
      list: {
        title: 'Property Users'
      },
      table: {
        userId: 'User ID',
        userName: 'User Name',
        tel: 'Phone',
        email: 'Email',
        address: 'Address',
        createTime: 'Create Time',
        levelCd: 'Role',
        ownerCount: 'Auth Count'
      },
      level: {
        admin: 'Admin',
        staff: 'Staff',
        user: 'User'
      },
      resetPwd: 'Reset Password',
      fetchError: 'Failed to fetch user list'
    }
  },
  zh: {
    systemUser: {
      search: {
        title: '查询条件',
        levelCd: '请选择人员角色',
        nameLike: '请输入用户名称',
        tel: '请输入手机号'
      },
      list: {
        title: '物业用户'
      },
      table: {
        userId: '用户编号',
        userName: '用户名称',
        tel: '手机号',
        email: 'Email',
        address: '地址',
        createTime: '创建时间',
        levelCd: '角色',
        ownerCount: '认证数'
      },
      level: {
        admin: '管理员',
        staff: '员工',
        user: '用户'
      },
      resetPwd: '重置密码',
fetchError: '获取用户列表失败'
    }
  },
  'zh-TW': {
    systemUser: {
      search: {
        title: '查詢條件',
        levelCd: '請選擇人員角色',
        nameLike: '請輸入用戶名稱',
        tel: '請輸入手機號'
      },
      list: {
        title: '物业用戶'
      },
      table: {
        userId: '用戶編號',
        userName: '用戶名稱',
        tel: '手機號',
        email: 'Email',
        address: '地址',
        createTime: '創建時間',
        levelCd: '角色',
        ownerCount: '認證數'
      },
      level: {
        admin: '管理員',
        staff: '員工',
        user: '用戶'
      },
      resetPwd: '重置密碼',
      fetchError: '獲取用戶列表失敗'
    }
  }
}